module.exports = __webpack_public_path__ + "static/img/4.8b0ceb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/4.png
// module id = YLKb
// module chunks = 96